const DEFAULT_RETRY_COUNT = 1;
const RETRY_DELAY = 10; // 10 ms delay between retries

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export async function fetchWithRetry(url, options = {}, maxRetries = DEFAULT_RETRY_COUNT) {
    let lastError;
    
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
            const response = await fetch(url, {
                ...options,
                headers: {
                    'Content-Type': 'application/json',
                    ...options.headers,
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            return data;
        } catch (error) {
            lastError = error;
            console.warn(`API call attempt ${attempt} failed:`, error);

            if (attempt === maxRetries) {
                break;
            }

            // Wait before retrying, with exponential backoff
            await sleep(RETRY_DELAY * Math.pow(2, attempt - 1));
        }
    }

    throw new Error(`Failed after ${maxRetries} attempts. Last error: ${lastError.message}`);
} 